import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import store from "./store";
import vuetify from "./plugins/vuetify";
import { instalarSesionAxios } from "./plugins/axiosSesion";
import dialogos from "./plugins/dialogos";

import "@mdi/font/css/materialdesignicons.css";
Vue.use(vuetify, { iconfont: "mdi" });

Vue.config.productionTip = false;

// this.$confirmar() / this.$avisar(): diálogos de la app en lugar de confirm()/alert()
Vue.use(dialogos);

// token de sesión en todas las peticiones a los backends; un 401 lleva al login
instalarSesionAxios({ store, router });

new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
